module.exports = __webpack_public_path__ + "img/pan.ea1e7cd3.png";